import { BasicProps } from "../../../common/components/ComponentsInterface";
import { LHero } from "../../../common/components/LHero";
import InternetConnectionModal from "./InternetConnectionModal";
import "./assessment-layout.scss";

export const AssessmentShell = ({ ...props }: AssessmentShellProps): JSX.Element => {
    return (
        <LHero
            className={`assessment-shell${
                props.separateMobileLandscapeTitle ? " assessment-shell-separate-title" : ""
            }`}
            centered
            contentCentered
            size="fullheight"
            includeUnauthenticatedMenu={!props.excludeUnauthenticatedMenu}
            navBarTitle={props.navBarTitle}
            showMic
            micVolume={props.micVolume}
            micIsRecording={props.micIsRecording}
        >
            <InternetConnectionModal />
            {props.children}
        </LHero>
    );
};

interface AssessmentShellProps extends BasicProps {
    navBarTitle?: string;
    micVolume?: number;
    micIsRecording?: boolean;
    excludeUnauthenticatedMenu?: boolean;
    separateMobileLandscapeTitle?: boolean;
}
